import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgCombinedChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M-0.00744629 36.0872C-0.00744629 33.2596 2.28478 30.9674 5.11238 30.9674H13.4527C16.2803 30.9674 18.5726 33.2596 18.5726 36.0872V58.8787C18.5726 61.7063 16.2803 63.9985 13.4527 63.9985H5.11238C2.28478 63.9985 -0.00744629 61.7063 -0.00744629 58.8787V36.0872Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.7018 27.8294C22.7018 25.0018 24.994 22.7095 27.8216 22.7095H36.1619C38.9895 22.7095 41.2818 25.0018 41.2818 27.8294V58.8786C41.2818 61.7062 38.9895 63.9984 36.1619 63.9984H27.8216C24.994 63.9984 22.7018 61.7062 22.7018 58.8786V27.8294Z",
			fill: "#BFDBFE"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.411 44.345C45.411 41.5174 47.7032 39.2252 50.5308 39.2252H58.8712C61.6988 39.2252 63.991 41.5174 63.991 44.345V58.8787C63.991 61.7063 61.6988 63.9986 58.8712 63.9986H50.5308C47.7032 63.9986 45.411 61.7063 45.411 58.8787V44.345Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M37.3367 10.0713C38.1312 8.96493 38.5872 7.59477 38.4993 6.11727C38.289 2.58088 35.2499 0.0640808 31.8164 0.170552C28.5059 0.273209 25.7401 2.70586 25.5368 6.11712C25.4829 7.02259 25.6286 7.89069 25.9323 8.68307L13.9663 16.8417C12.7316 15.611 11.0283 14.8502 9.14721 14.8502C5.37707 14.8502 2.32077 17.9065 2.32077 21.6766C2.32077 25.4467 5.37707 28.503 9.14721 28.503C12.9173 28.503 15.9736 25.4467 15.9736 21.6766C15.9736 20.7095 15.7725 19.7894 15.4099 18.9558L27.3167 10.8375C28.4632 12.0134 30.0616 12.7615 31.8163 12.8161C33.1463 12.8575 34.408 12.4827 35.4676 11.8206L49.0048 25.9732C48.2076 27.0901 47.7386 28.4575 47.7386 29.9344C47.7386 33.7045 50.7949 36.7608 54.565 36.7608C58.3351 36.7608 61.3914 33.7045 61.3914 29.9344C61.3914 26.1643 58.3351 23.108 54.565 23.108C53.1968 23.108 51.9227 23.5104 50.8545 24.2035L37.3367 10.0713Z",
			fill: "#60A5FA"
		})
	]
});
export default SvgCombinedChart;
